import React, { FC, ReactElement } from 'react';
import { Card, Empty } from "antd";
import { Radar, RadarConfig } from '@ant-design/plots';
import { SpinContainer } from '../../../SpinContainer';
import { Props as SectionPerformanceProps } from './SectionPerformanceCard';
import { FeedbackRowProps } from '../../ActivityFeedbackRows/types';
import {useSectionPerformanceFirstBestData} from './useSectionPerformanceFirstBestData';

interface Props extends Pick<FeedbackRowProps, 'activityId'> {
    title?: React.ReactNode;
    type: SectionPerformanceProps['type']
    defaultFilters?: { [key: string]: (string | number | string[] | number []) }
}

const FIRST_SCORE_COLOR = '#8c8c8c';
const BEST_SCORE_COLOR = '#1677ff';
export const SectionPerformanceRadarPlot: FC<Partial<RadarConfig> & Omit<Props, 'title'>> = ({type, defaultFilters, activityId, ...radarConfig}) => {
    const {seriesData: chartData, isLoading} = useSectionPerformanceFirstBestData({
        type,
        activityId,
        defaultFilters,
    });
    if (isLoading) return <SpinContainer/>;
    if (chartData.length === 0) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;

    return (
       <Radar
            data={chartData}
            xField='title'
            yField='score'
            seriesField='series'
            appendPadding={5}
            color={({series}) => series === 'First' ? FIRST_SCORE_COLOR : BEST_SCORE_COLOR}
            yAxis={{
                min: 0,
                max: 100,
                tickCount: 5,
                label: {
                    formatter: (value: string) => `${value}%`,
                },
            }}
            point={{size: 3}}
            area={{}}
            tooltip={{
                formatter: (datum) => ({
                    name: `${datum.series} Score`,
                    value: `${datum.score}%`,
                }),
            }}
        /> 
    )

}
export const SectionPerformanceRadarPlotCard: FC<Props> = ({type, title, defaultFilters, activityId}): ReactElement => {
    return (
        <Card title={title} className='chart-card'>
            <SectionPerformanceRadarPlot type={type} defaultFilters={defaultFilters} activityId={activityId}/>
        </Card>
    );
};
